import { defineAsyncComponent } from 'vue'
import PopupName from '@/commons/wildcards/constants/PopupName'

const demoFormPopup = defineAsyncComponent(() =>
  import('@/views/demo/DemoFormPopup.vue')
)

const authenticateRequirePopup = defineAsyncComponent(() =>
  import('@/views/create/AuthenticateRequirePopup.vue')
)

const changePasswordPopup = defineAsyncComponent(() =>
  import('@/views/profile/popup/ChangePasswordPopup.vue')
)

const forgotPasswordPopup = defineAsyncComponent(() =>
  import('@/views/account/forgotPassword/ForgotPassword.vue')
)

const chooseSchoolLevelPopup = defineAsyncComponent(() =>
  import('@/views/detail/ChooseSchoolLevelPopup.vue')
)

const mobileProfileSearchPopup = defineAsyncComponent(() =>
  import('@/views/detail/MobileProfileSearchPopup.vue')
)

export function registerBusinessPopup (app) {
  app.component(PopupName.DemoFormPopup, demoFormPopup)
  app.component(PopupName.ForgotPasswordPopup, forgotPasswordPopup)
  app.component(PopupName.ChangePasswordPopup, changePasswordPopup)
  app.component(PopupName.AuthenticateRequirePopup, authenticateRequirePopup)
  app.component(PopupName.ChooseSchoolLevelPopup, chooseSchoolLevelPopup)
  app.component(PopupName.MobileProfileSearchPopup, mobileProfileSearchPopup)
}
